import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import IconButton from '../../common/IconButton';

export const Container = styled.div<{isLoading?: boolean}>`
  display: flex;
  overflow: hidden;
  width: 327px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.07);
  padding: 16px 6px 16px 16px;

  ${props =>
    props.isLoading &&
    css`
      cursor: progress;
      opacity: 0.6;
    `};

  @media (max-width: ${device.mobileXL}) {
    width: 100%;
  }
`;

export const ContentTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 190px;
  padding: 0 8px 0 0;
  border-right: 1px solid rgba(0, 0, 0, 0.07);
`;

export const ContentEditButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  width: 47px;
  height: 24px;
  gap: 4px;
  transition: opacity 0.1s ease-in-out;

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: #393abd;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const ContentPrice = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-left: 8px;
`;

export const SubContainerPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: 100%;
`;

export const Title = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #152946;
`;

export const Label = styled.span`
  display: block;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #777e91;
`;

export const SubTitle = styled.span<{blue: boolean}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #eaecef;
  border-radius: 5px;
  width: max-content;
  height: 30px;
  padding: 8px;
  margin-top: 8px;

  font-weight: 600;
  font-size: 12px;
  color: ${props => (props.blue ? '#385BF8' : '#777e91')};
`;

export const EditIcon = styled.img`
  width: 18px;
`;

export const DotsButton = styled(IconButton)`
  margin-left: 6px;
  width: 24px;
  height: 24px;
  padding: 0;
  display: block;
  position: relative;
  transition: opacity 0.1s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

export const Price = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: #152946;
`;

export const Fee = styled.div`
  margin-right: 30px;
  display: flex;
  justify-content: end;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  color: #777e91;
`;
